import { UserBarType, userType } from "../../types/types";
import apiClient from "../api/api";
import { userResponseType } from "../../types/userAllTypes";

export const fetchGetMe = async () => {
  const response = await apiClient.get("/me");

  return response.data;
};
export const fetchGetMeID = async (id: number) => {
  const response = await apiClient.get("/users/" + id);
  return response.data;
};

export const fetchGetMeStudentTeacherID = async (type: string, id: number) => {
  const response = await apiClient.get("/" + type + "/" + id);
  return response.data;
};

export const fetchUsers = async () => {
  const response = await apiClient.get("/users/");
  return response.data;
};

export const createUser = async (
  newUser: userType
): Promise<userResponseType> => {
  const response = await apiClient.post("/employees/", newUser);
  return response.data;
};

export const updateUser = async (
  userId: string,
  userData: { name?: string; email?: string }
) => {
  const response = await apiClient.put(`/users/${userId}`, userData);
  return response.data;
};

export const deleteUserService = async (userId: number) => {
  const response = await apiClient.delete(`/students/${userId}`);
  return response.data;
};

export const deleteEmployeeService = async (userId: number) => {
  const response = await apiClient.delete(`/employees/${userId}`);
  return response.data;
};

export async function fetchUserBar({ user_id, role, start_date, end_date }: UserBarType) {
  const response = await apiClient.get(`/user/${user_id}/bar/`, {
    params: {
      user_type: role,
      ...(start_date != null ? { start_date } : {}),
      ...(end_date != null ? { end_date } : {}),
    },
  });

  return response.data;
}

export async function fetchUserMonthlyAttendance({
  user_id,
  role,
  start_date,
  end_date,
}: UserBarType) {
  const response = await apiClient.get(`/user/${user_id}/yearly`, {
    params: {
      user_type: role,
      start_date,
      end_date,
    },
  });

  return response.data;
}

export async function fetchUserSchedule({ user_id, role }: UserBarType) {
  const response = await apiClient.get(`/user/${user_id}/list-last-schedule/`, {
    params: {
      user_type: role,
    },
  });

  return response.data;
}
